module.exports = __webpack_public_path__ + "img/finke-media.09289d09.png";